const clean = (value) => value?.trim().toUpperCase() ?? '';
/** The nine-character material number embeds the documented three-character material category. */
export function trimTypeOf(row) {
    const explicit = clean(row.typeCd ?? row.subMaterialTypeCd);
    if (explicit)
        return explicit;
    const types = [...new Set([row.code, row.subMaterialCd, ...(row.aliasCodes ?? [])]
            .map(code => clean(code).match(/^(3\d{2})[A-Z]{2}\d{4}$/)?.[1]).filter(Boolean))];
    return types.length === 1 ? types[0] : null;
}
export function isSewingThread(row) {
    if (row.bomGroup === 'THREAD' || trimTypeOf(row) === '320')
        return true;
    return ['THREAD', 'SEWING THREAD', '缝纫线', '缝制线', '재봉사', '봉제사'].includes(clean(row.contents ?? row.name));
}
const items = {
    'THREAD': { unit: null, rule: 'thread' },
    'SEWING THREAD': { unit: null, rule: 'thread' },
    'TAPE': { unit: 'M', rule: 'item:tape' },
    'NECK TAPE': { unit: 'M', rule: 'item:tape' },
    'PIPING TAPE': { unit: 'M', rule: 'item:tape' },
    'PIPING': { unit: 'M', rule: 'item:tape' },
    'STRIPE TAPE': { unit: 'M', rule: 'item:tape' },
    '3M TAPE': { unit: 'M', rule: 'item:tape' },
    'LACE': { unit: 'M', rule: 'item:lace' },
    'BAND': { unit: 'EA', rule: 'item:elastic', countAsStrand: true },
    'E-BAND': { unit: 'EA', rule: 'item:elastic', countAsStrand: true },
    'BUTTON BAND': { unit: 'EA', rule: 'item:elastic', countAsStrand: true },
    'LOGO BAND': { unit: 'EA', rule: 'item:elastic', countAsStrand: true },
    'STRING': { unit: 'EA', rule: 'item:cord', countAsStrand: true },
    'E-STRING': { unit: 'EA', rule: 'item:cord', countAsStrand: true },
    'STRING+TIP': { unit: 'EA', rule: 'item:cord', countAsStrand: true },
    'STRING+STRING TIP': { unit: 'EA', rule: 'item:cord', countAsStrand: true },
};
for (const item of ['BUTTON', 'CANTON', 'SNAP', 'STOPPER', 'LABEL', 'M/LABEL', 'P/LABEL', 'SIZE LABEL', 'PRINT LABEL', 'METAL LABEL', 'POINT LABEL', 'WAPPEN', 'WAPEN', 'TAG', 'EYELET', 'RIVET', 'BUCKLE', 'D-RING', 'ZIPPER', 'ZIPPER TAB', 'ZIPPER PULLER', 'ZIPPER TAB+PULLER', 'ZIPPER+ZIPPER TAB', 'ZIPPER PULLER+ZIPPER TAB']) {
    items[item] = { unit: 'EA', rule: 'item:piece' };
}
const categories = {
    '橡筋': { unit: 'EA', rule: 'category:elastic', countAsStrand: true },
    '绳子': { unit: 'EA', rule: 'category:cord', countAsStrand: true },
    '织带': { unit: 'M', rule: 'category:tape' },
};
for (const category of ['纽扣', 'SNAP', '停止扣', '织标,尺寸标,装饰标', '刺绣标/装饰.VELCRO', '带有橡胶的标', '吊牌', '搭扣', '拉片装饰', '拉链牙齿', '气眼', '铆钉']) {
    categories[category] = { unit: 'EA', rule: 'category:piece' };
}
/** Conservative defaults: no fallback to EA when neither category nor a recognised item exists. */
export function defaultTrimUnit(row) {
    if (isSewingThread(row))
        return { unit: null, rule: 'thread' };
    const item = items[clean(row.item)];
    const category = categories[clean(row.category)];
    if (category)
        return category.countAsStrand && item?.unit === 'M' ? item : category;
    if (item)
        return item;
    const type = trimTypeOf(row);
    if (type === '301' || type === '311' || type === '312')
        return { unit: 'EA', rule: `type:${type}`, countAsStrand: true };
    if (['306', '314', '315', '319', '321', '328', '336', '339', '341'].includes(type ?? ''))
        return { unit: 'M', rule: `type:${type}` };
    if (type === '304')
        return { unit: 'KG', rule: 'type:304' };
    if (['302', '303', '307', '309', '310', '313', '316', '317', '318', '322', '323', '324', '325', '326', '327', '329', '330', '331', '332', '333', '334', '335', '337', '338', '340', '342'].includes(type ?? ''))
        return { unit: 'EA', rule: `type:${type}` };
    return null;
}
/** EA remains the stored count unit; Chinese uses 根 for individual elastic/cord pieces. */
export function trimCountLabelKey(row, unit) {
    if (!['EA', 'PC', 'PCS'].includes(clean(unit)))
        return null;
    return defaultTrimUnit(row)?.countAsStrand ? 'trimUnits.strand' : 'trimUnits.piece';
}
//# sourceMappingURL=trim-units.js.map